import 'jquery'
import 'bootstrap'

import '../../common/js/formvalidation-advanced';
import '../../common/js/menu';
import '../../common/js/paneladding';
import '../../common/js/draft-form';
import '../../common/js/showfilename';
import '../../common/js/disableselectbox';
import '../../common/js/collapse';
import '../../common/js/collapse-marital-status';
import '../../common/js/currency';
